import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import '../css/Dashboard.css';
import { memo } from "react";
import { KioskDashboardActions } from "../_store";
import TranslateFile from "../Loc/TranslateFile";
import { showAlert } from "../components/common/showAlert";
import useKioskRestrictIntervalValidation from "../hooks/useKioskRestrictIntervalValidation";
import { getStoredValue , setStoredValue } from "../../src/_helpers/storageHelper";

const Dashboard = () => {
    const navigate = useNavigate();
    const LoadInmateMainMenuDetails = useSelector(state => state.KioskDashboard.LoadInmateMainMenuDetails);
    const inmateMenuList = LoadInmateMainMenuDetails?.length > 0 ? LoadInmateMainMenuDetails : getStoredValue("inmateMenuList");
    const storedloginResponse = getStoredValue("loginResponse");
    const dispatch = useDispatch();
    const currentLang = TranslateFile();
    const storedLoginDetails = getStoredValue("loginDetails");
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();

    useEffect(() => {
        if (LoadInmateMainMenuDetails?.length > 0) {
            setStoredValue("inmateMenuList", LoadInmateMainMenuDetails);
        }
    }, [LoadInmateMainMenuDetails]);

    useEffect(() => {
        const podCode = storedLoginDetails?.PodCode;
        const inmateID = storedloginResponse?.InmateID;
        if (inmateID && podCode) {
            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }))
        }
    }, []);

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);


    const getTitle = (menuName) => {
        const titleMap = {
            Messages: currentLang?.MenuHeaders?.Messages,
            Photos: currentLang?.MenuHeaders?.Photos,
            Requests: currentLang?.MenuHeaders?.Requests,
            Documents: currentLang?.MenuHeaders?.Documents,
            "Postal Mails": currentLang?.MenuHeaders?.Postal_Mails,
            "My Contacts": currentLang?.MenuHeaders?.My_Contacts,
            "Law Library": currentLang?.MenuHeaders?.Law_Library,
            "My Invites": currentLang?.MenuHeaders?.My_Invites,
            "Place Order": currentLang?.MenuHeaders?.Place_Order,
            "My Profile": currentLang?.MenuHeaders?.My_Profile,
            "E-Cards": currentLang?.MenuHeaders?.E_Card,
        };
        return titleMap[menuName] || menuName; // Default to empty string if not found
    };

    // Map through the menu list and transform the paths and icons
    const dashboardItems = inmateMenuList?.map((item) => {
        const menuPaths = item.NewMenuRedirectPath || item.AppMenuRedirectPath;
        return {
            path: menuPaths.replace('../Kiosk.v1/', '/').replace('.aspx', ''), // Adjust path format
            icon: getIcon(item.MenuName), // Custom function to assign correct icons
            title: getTitle(item.MenuName), badge: item?.UnReadCount,
            menuName: item.MenuName,
        };
    });

    // Custom function to map icons to MenuName
    function getIcon(menuName) {
        switch (menuName) {
            case 'Messages': return 'fa-regular fa-envelope';
            case 'Photos': return 'fa-regular fa-image';
            case 'Requests': return "fa-solid fa-user-plus";
            case 'Documents': return 'fa fa-file-text';
            case 'Postal Mails': return 'fa fa-newspaper';
            case 'My Contacts': return 'fa fa-address-card';
            case 'Law Library': return 'fa fa-balance-scale';
            case 'My Invites': return 'fa fa-users';
            case 'Place Order': return 'fa fa-shopping-cart';
            case 'My Profile': return 'fa-regular fa-user';
            case "E-Cards": return "fa-regular fa-id-card";
            default: return '';
        }
    }

    const handleClick = async (item, allmenus) => {

        const podCode = storedLoginDetails?.PodCode;
        const inmateID = storedloginResponse?.InmateID;
        if (inmateID && podCode) {
            await dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode })).then(x => {
                if (x?.payload?.length > 0) {
                    let menuAcess = x?.payload?.filter((x) => x.MenuName === item?.menuName);
                    if (menuAcess?.length == 0) {
                        let firstmenu = x?.payload[0];
                        let nestmenu = allmenus?.filter((x) => x.title === firstmenu?.MenuName);
                        showAlert(null, currentLang?.AlertPopup?.Access_Denied, `${currentLang?.AlertPopup?.Dont_Have_Access_Menu} ${item?.menuName}`, "error",);
                        navigate(nestmenu[0]?.path);
                        return;
                    }
                    else {
                        navigate(item?.path || '/Dashboard');
                    }
                }
            });
        }
        else {
            navigate(item?.path || '/Dashboard');
        }
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="icon-container">
                    <h3 className="find-inmate-head">{currentLang?.DASHBOARD}</h3>
                </div>
                <div className="divider mb-3"></div>

                <div className="dashboard-grid">
                    {dashboardItems?.map((item, index) => (
                        <div
                            key={index}
                            title={item.title}
                            className="dashboard-card"
                            onClick={() => handleClick(item, dashboardItems)}
                        >
                            <div className="form-row-dashboard ">
                                <div >
                                    <i className={item.icon} style={{ color: '#ffffff', fontSize: '42px' }}></i>
                                </div>
                                <div className="text-container">
                                    <h3>{item?.title?.toUpperCase()}</h3>
                                </div>
                                {item.badge !== 0 && (
                                    <div className="badge custom-size">{item.badge}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default memo(Dashboard);
